import { EMPTY_ITEM_RIGHTS_COLLECTION } from "Global/Base/Rights/RightTypes";
import { Localization } from "../../../../../../OW.Remoting/Remoting/Localization";
import { EventHelper } from "../../../../../UI.BaseControls/Helpers/EventHelper";
import { Action } from "../../../../../UI.Controls/Actions/Action";
import { DropDownMenuItem } from "../../../../../UI.Controls/DropDownMenu/DropDownMenuItem";
import { createElement, registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { CheckBox2s } from "../../../Controls/CheckBox2s";

export class DropDownMenuCheckboxItem extends DropDownMenuItem {
    private _checkboxItem: CheckBox2s;
    private _value: any;
    private _valueType: string;
    private _container: HTMLElement;

    public valueId: string;

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    public get isChecked(): boolean {
        return this._checkboxItem.controlValue;
    }

    public set isChecked(v: boolean) {
        this._checkboxItem.controlValue = v;
    }

    /**
     * Hodnota, ktera se preda pokud je zaskrtnutny
     */
    public get value(): any {
        return this._value;
    }

    public set value(v: any) {
        this._value = v;
    }

    public get valueType(): string {
        return this._valueType;
    }

    public set valueType(v: string) {
        this._valueType = v;
    }

    protected override _constructor(): void {
        super._constructor();

        //this.Priority = ;
        //this.locKey = locKey;
        this.visible = true;
        //if (subMenu) this.Submenu = subMenu;
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "CheckboxItem");
        this._container = createElement({ type: "div", classes: "container" });
        const checkElement = document.createElement("div");
        this._checkboxItem = new CheckBox2s({ element: checkElement, originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION });
        this._createCaptionElement();

        this._container.appendChild(checkElement);
        this._container.appendChild(this._captionElement);

        this.appendChild(this._container);

        this.action = new Action(async () => {
            this._checkboxItem.controlValue = !this._checkboxItem.controlValue;
        });
        this.noCloseAfterSelect = true;
    }

    protected override _createCaptionElement(): void {
        this._captionElement = document.createElement("div");
        this._captionElement.classList.add("Caption");

        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }
    }

    protected override _setListener(): void {
        super._setListener();
        this._checkboxItem.element.addEventListener("click", (e: MouseEvent) => { // prevzato z DropDownMenuItem
            if (e.button === 0) {
                e.preventDefault(); // event se spoustel 2x
                EventHelper.stopImmediatePropagation(e);
                if (!this.classList.contains("Disabled")) {
                    if (this.action instanceof Action) {
                        (this.action as Action).execute();
                    }
                    if (!this.noCloseAfterSelect)
                        this.parent.closeAll();

                    this.callEvent("change");
                }
            }
        });
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuCheckboxItem", DropDownMenuCheckboxItem);
